import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from "../../../features/authentication/contexts/AuthContext";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useAppDispatch } from '../../../utils/hooks';
import { fetchError } from '../../../redux/actions';

function SubscriptionSuccess() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const searchParams = new URLSearchParams(location.search);
    const query = searchParams.get('success');
    let auth = useAuthContext();

    useEffect(() => {
        if (query === 'true') {
          // If subscription success check if database updated yet and user has a tier
          const intervalId = setInterval(() => {
            auth.retrieveUserRoles();
            if (auth.isSubscribedUser()) {
                clearInterval(intervalId);
                navigate('/beacons');
            }
          }, 2000); // Check every 2 seconds


        return () => {
          clearInterval(intervalId);
        };

      } else {
        // Subscription failed send them back to subscription/ dashboard page
        dispatch(fetchError("Subscription failed"));
        // Redirect back to dashboard page temporarily for event, only singular sub card shown on dashboard
        navigate('/beacons');
      }
    }, [auth, navigate, query]);

    return (
      <>
        <Box sx=
        {{ 
          display: "flex",
          flexDirection: "column", 
          justifyContent: "center", 
          alignItems: "center", 
          minHeight: "100vh" 
        }}>
          <CircularProgress />
          <Typography sx={{ 
            mt: 6,
          }}>
            Please wait while we activate your subscription...
          </Typography>
        </Box>
      </>
    );
}

export default SubscriptionSuccess;
